// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__HOBVS","productName":"Table_productName__3w7K_"};